// Libraries
import React from 'react';

// Supermove
import {Styled, Space} from '@supermove/components';

// App
import Badge from '@shared/design/components/Badge';

const Row = Styled.View`
  flex-direction: row;
`;

const LoadingStageTabs = () => {
  return (
    <React.Fragment>
      <Row style={{paddingLeft: 24}}>
        <Badge.Loading />
        <Space width={24} />
        <Badge.Loading />
        <Space width={24} />
        <Badge.Loading />
        <Space width={24} />
        <Badge.Loading />
        <Space width={24} />
        <Badge.Loading />
      </Row>
      <Space height={6} />
    </React.Fragment>
  );
};

export default LoadingStageTabs;
